import React, { useEffect, useState } from "react";
import CardItem from "./Components/CardItem";
import Summary from "./Sub-Pages/Summary";
import axios from "axios";
import ImageLoading from "../../../components/ImageLoading";
import VanishComponent from "../../../components/VanishComponent";
import BsaModal from "../../KYC/BsaModal";
import Categories from "./Sub-Pages/Categories";

function RightPage({ bank, id, bankName, image }) {
  const [BsaFilter, setBsaFilter] = useState("Summary");
  const [loading, setLoading] = useState(true);
  const [metrics, setMetrics] = useState({});
  const [Nodata, setNodata] = useState(false);
  const [openBsa, setOpenBsa] = useState(false);

  const [noDownloadData, setNoDownloadData] = useState(false);

  const bsaFilterItems = ["Summary", "Categorization"];
  const fetchDashboardMetrics = async () => {
    if (bank !== null && bank !== undefined) {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const options = {
          url: `${process.env.REACT_APP_URL}/lender/v1/dashboard_analyser/${bank}/dashboard_metrics`,
          method: "GET",
          headers: { Authorization: token },
        };
        const res = await axios(options);
        if (res.data?.dashboard_metrics) {
          setMetrics(res.data?.dashboard_metrics);
          setNodata(false);
        } else {
          setMetrics({});
          setNodata(true);
        }
      } catch (error) {
        setMetrics({});
        setNodata(true);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    fetchDashboardMetrics();
  }, [bank]);
  return (
    <>
      <div className=" w-full ml-4 bg-white rounded h-[calc(100vh-190px)] overflow-y-auto p-4">
        {loading && (
          <div className=" w-full h-[calc(100vh-650px)] flex justify-center items-center">
            <ImageLoading />
          </div>
        )}

        {!loading && !Nodata && (
          <>
            <p className=" text-base font-bold">Dashboard</p>
            <div className=" flex items-center justify-between mt-4">
              <CardItem
                name={"Total Income"}
                value={metrics?.static?.total_income}
                percentage={Math.abs(
                  metrics?.static?.income_change
                    ? metrics?.static?.income_change
                    : 0
                )}
                trend={
                  metrics?.static?.income_change < 0
                    ? "down"
                    : metrics?.static?.income_change > 0
                    ? "up"
                    : "flat"
                }
                bg={"#f3f3f3"}
              />
              <CardItem
                name={"Total Expenses"}
                value={metrics?.static?.total_expense}
                percentage={Math.abs(
                  metrics?.static?.expense_change
                    ? metrics?.static?.expense_change
                    : 0
                )}
                trend={
                  metrics?.static?.expense_change < 0
                    ? "down"
                    : metrics?.static?.expense_change > 0
                    ? "up"
                    : "flat"
                }
                bg={"#f3f3f3"}
              />
              <CardItem
                name={"Net Income"}
                value={metrics?.static?.total_netflow}
                percentage={Math.abs(
                  metrics?.static?.netflow_change
                    ? metrics?.static?.netflow_change
                    : 0
                )}
                trend={
                  metrics?.static?.netflow_change < 0
                    ? "down"
                    : metrics?.static?.netflow_change > 0
                    ? "up"
                    : "flat"
                }
                bg={"#f3f3f3"}
              />
            </div>
            <div className=" flex items-center justify-between mt-4">
              <CardItem
                name={"Saving Balance"}
                value={metrics?.static?.current_balance}
                percentage={Math.abs(
                  metrics?.static?.balance_change
                    ? metrics?.static?.balance_change
                    : 0
                )}
                trend={
                  metrics?.static?.balance_change < 0
                    ? "down"
                    : metrics?.static?.balance_change > 0
                    ? "up"
                    : "flat"
                }
                bg={"#f3f3f3"}
              />
              <CardItem
                name={"Debt-to-Income Ratio"}
                value={metrics?.static?.debt_to_income}
                percentage={Math.abs(
                  metrics?.static?.debt_to_income
                    ? metrics?.static?.debt_to_income
                    : 0
                )}
                trend={
                  metrics?.static?.debt_change < 0
                    ? "down"
                    : metrics?.static?.debt_change > 0
                    ? "up"
                    : "flat"
                }
                bg={"#f3f3f3"}
              />
              <CardItem
                name={"Net Invested Amount"}
                value={Math.abs(
                  metrics?.static?.investment_netflow
                    ? metrics?.static?.investment_netflow
                    : 0
                )}
                percentage={Math.abs(
                  metrics?.static?.invest_change
                    ? metrics?.static?.invest_change
                    : 0
                )}
                trend={
                  metrics?.static?.invest_change < 0
                    ? "down"
                    : metrics?.static?.invest_change > 0
                    ? "up"
                    : "flat"
                }
                bg={"#f3f3f3"}
              />
            </div>
            <div className=" h-[1px] bg-[#f3f3f3] w-full mt-4"></div>
            <div className=" flex items-center justify-between  mt-4">
              <div className="flex justify-between items-center  rounded-lg w-fit bg-[#F4F4F4] py-0.5 px-0.5 h-[32px]">
                {bsaFilterItems.map((item, index) => (
                  <button
                    key={index}
                    className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                      BsaFilter === item ? "bg-white rounded" : ""
                    }`}
                    onClick={() => setBsaFilter(item)}
                  >
                    {item}
                  </button>
                ))}
              </div>
              <button
                className="w-[110px] h-8   bg-[#00394d] rounded text-white text-sm font-semibold"
                title="Bank Statement Analyzer"
                onClick={(e) => {
                  setOpenBsa(true);
                }}
              >
                Download
              </button>
            </div>
          </>
        )}

        {BsaFilter === "Summary" && (
          <Summary bank={bank} id={id} fetch={fetch} />
        )}
        {BsaFilter === "Categorization" && (
          <Categories bank={bank} id={id} fetch={fetch} />
        )}
      </div>
      {openBsa && (
        <BsaModal
          setOpenBsa={setOpenBsa}
          detailId={bank}
          bankName={bankName}
          image={image}
          setNoDownloadData={setNoDownloadData}
        />
      )}
      <VanishComponent
        error={noDownloadData}
        errorFunction={() => {
          setNoDownloadData(false);
        }}
        errorMessage={`No records found`}
        timeOut={5000}
      />
    </>
  );
}

export default RightPage;
